export function adminPortalPostLoginPath(enabled, redirectPath) {
  if (!enabled) return null;
  if (!redirectPath || !redirectPath.startsWith("/") || redirectPath.startsWith("//")) return "/";
  return redirectPath;
}

export function completeAdminPortalLogin(enabled, redirectPath, browserLocation = window.location) {
  const destination = adminPortalPostLoginPath(enabled, redirectPath);
  if (!destination) return false;

  // Re-enter through the document boundary so AuthProvider hydrates from the
  // newly issued HttpOnly session before a protected portal route renders.
  browserLocation.replace(destination);
  return true;
}

export function adminPortalReturnPath(location) {
  return `${location.pathname}${location.search || ""}${location.hash || ""}`;
}
